import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
export const DOSSIER_ERRORS = gql `
  query dossierErrors($dossierId: Long) {
    dossier_errors(dossierId: $dossierId)
  }
`;
export const useDossierErrorsLazyQuery = (options) => {
    return useLazyQuery(DOSSIER_ERRORS, Object.assign({ errorPolicy: 'all' }, options));
};
export const useDossierErrorsQuery = (options) => {
    return useQuery(DOSSIER_ERRORS, Object.assign({ errorPolicy: 'all' }, options));
};
export const useDossierErrorsQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: DOSSIER_ERRORS, variables }));
};
